export default __webpack_public_path__ + "static/media/books_2.2335081c.svg";